import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/data/content";
import { useLang } from "@/i18n/LanguageContext";
import { useSeo } from "@/hooks/useSeo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const { ui } = useContent();
  const { lang } = useLang();
  const u = ui.unsubscribe;
  useSeo({ title: u.title, description: u.body, noindex: true });
  const [email, setEmail] = useState(params.get("email") || "");
  const [done, setDone] = useState(false);
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSending(true);
    try {
      await axios.post(`${API}/newsletter/unsubscribe`, { email, lang });
    } catch {
      // the endpoint is idempotent; either way the address is gone
    } finally {
      setDone(true);
      setSending(false);
    }
  };

  return (
    <main className="bg-cream min-h-screen" data-testid="unsubscribe-page">
      <section className="mx-auto max-w-xl px-6 pt-48 pb-32 text-center">
        <Reveal>
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-ink" data-testid="unsubscribe-title">{u.title}</h1>
          {done ? (
            <p className="mt-8 font-serif italic text-xl text-clay" data-testid="unsubscribe-done">{u.done}</p>
          ) : (
            <form onSubmit={submit} className="mt-10" data-testid="unsubscribe-form">
              <p className="text-base leading-relaxed text-soft">{u.body}</p>
              <label htmlFor="unsubscribe-email" className="sr-only">{u.placeholder}</label>
              <input
                id="unsubscribe-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={u.placeholder}
                data-testid="unsubscribe-email-input"
                className="mt-8 w-full bg-transparent border-b border-ink/25 py-3 text-center text-base text-ink outline-none placeholder:text-soft/50 focus:border-clay transition-colors duration-300"
              />
              <button
                type="submit"
                disabled={sending}
                data-testid="unsubscribe-submit"
                className="mt-8 inline-flex items-center gap-3 rounded-full border border-clay px-8 py-3.5 text-sm tracking-wide text-clay transition-colors duration-300 hover:bg-clay hover:text-cream disabled:opacity-50"
              >
                {sending ? u.sending : u.cta}
              </button>
            </form>
          )}
        </Reveal>
      </section>
    </main>
  );
}
